<template>
  <v-dialog v-model="internalDialogVisible"
            width="600px">
    <v-card>
      <v-card-title class="pb-0">Add New User</v-card-title>
      <v-card-title class="subtitle-2 pt-0 font-weight-light">Required fields are indicated with *</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="firstName"
                :rules="[v => !!v || 'First Name is required']"
                label="First Name *"
                required />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lastName"
                :rules="[v => !!v || 'Last Name is required']"
                label="Last Name *"
                required />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email Address *" />
            </v-col>
          </v-row>
          <v-row>
            <!-- we need to force the width because the alert does not respect the width of the card in IE11 -->
            <v-alert v-if="!showAddError" width="576px" type="warning">
              <b>This change will impact the cost of future invoices you receive from HawkSoft.</b> By submitting this request, you agree to these changes.
            </v-alert>
            <v-alert v-model="showAddError" type="error" dense outlined prominent dismissible>Error sending seat change addition request, please try again or contact customer support.</v-alert>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn depressed tile @click="close()">Cancel</v-btn>
        <v-btn depressed tile color="primary" :disabled="!valid || disableSubmit" @click="addUser()">Add User</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'RemoteAgencyNewUserDialog',
  props: {
    showNewUserDialog: Boolean,
    hostType: { required: true, type: Number }
  },
  data () {
    return {
      valid: true,
      showAddError: false,
      firstName: '',
      lastName: '',
      email: '',
      disableSubmit: false,
      emailRules: [
        v => (!!v && /^\S+@\S+\.\S+$/.test(v) && v.length < 141) || 'Email not valid, please enter in the following format: email@domain.com'
      ]
    };
  },
  computed: {
    ...mapState(['agency', 'agencyUser']),
    internalDialogVisible: {
      get: function () {
        return this.showNewUserDialog;
      },
      set: function (visible) {
        if (!visible) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    close: function () {
      this.$refs.form.reset();
      this.internalDialogVisible = false;
    },
    async addUser () {
      this.disableSubmit = true;
      var payload = {
        AgencyId: this.agency.agencyId,
        AgencyName: this.agency.name,
        RequestedBy: this.agencyUser.name,
        Quantity: 1,
        AgencyType: this.hostType,
        FirstName: this.firstName,
        LastName: this.lastName,
        Email: this.email
      };
      var response = await this.$api.createAgencySeatRequest(payload);
      if (response.code !== 0 && response.code !== 2) {
        this.showAddError = true;
        this.disableSubmit = false;
        return;
      }
      var tableId = JSON.parse(response.data[0]).data[0];
      this.$emit('success',
        {
          requestedBy: payload.RequestedBy,
          quantity: payload.Quantity,
          firstName: payload.FirstName,
          lastName: payload.LastName,
          email: payload.Email,
          id: tableId,
          status: 'Available'
        }
      );
      this.disableSubmit = false;
      this.close();
    }
  }
};
</script>

<style scoped>

</style>
